export const convertToBoolean = (s) => {
    try {
        return JSON.parse(s);
    }
    catch (e) {
        return false;
    }
};
